export default class Ease {

	constructor() {
		this.time = 1;
		this.step = 1;
	}

	go(object, targets, duration=500) {
		this.object = object;
		this.initial = {};
		for(let name in targets) this.initial[name] = parseFloat(this.object[name]);
		this.targets = targets;
		this.step = 1000/duration/1000;
		this.time = -1;
	}

	update(delta) {
		if(this.time < 1) {
			if(this.time < 0) {
				// begin next update
				this.time = 0;
			} else {
				this.time += this.step * delta;
				if(this.time > 1) this.time = 1;
				for(let name in this.targets) {
					let d = this.targets[name] - this.initial[name];
					this.object[name] = this.initial[name] + (this.ease(this.time) * d);
				}
			}
			return true; // active
		}
		return false; // finished
	}

	ease(x) {
		return -(Math.cos(Math.PI * x) - 1) / 2;
	}

}